import { render, staticRenderFns } from "./article-form.vue?vue&type=template&id=4efcd424&scoped=true&"
import script from "./article-form.vue?vue&type=script&lang=js&"
export * from "./article-form.vue?vue&type=script&lang=js&"
import style0 from "./article-form.vue?vue&type=style&index=0&id=4efcd424&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../tmp/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efcd424",
  null
  
)

export default component.exports